<div class="kng-loader">
  <img class="kng-loader--image" src="{{ state.imagePath }}" alt="loader" aria-label="Loading"/>
</div>
